import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield, CreditCard, Clock, Home, AlertCircle, Lock, FileText } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Page Title */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
            <FileText className="w-8 h-8 text-blue-600" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Terms and Conditions</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Please read these terms and conditions carefully before using our services.
          </p>
        </div>

        {/* Terms Content */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="p-8 space-y-12">
            
            {/* Section 1: Booking Process */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3 mb-4">
                <div className="flex items-center justify-center w-10 h-10 bg-pink-100 rounded-lg">
                  <Home className="w-5 h-5 text-pink-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">1. Booking Process</h2>
              </div>
              <ul className="space-y-3 text-gray-700 ml-4">
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>All bookings must be made through our official booking system.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Bookings are subject to availability and cannot be guaranteed until confirmed.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Guests must be at least 18 years old to make a booking.</span>
                </li>
              </ul>
            </div>

            {/* Section 2: Payment Terms */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3 mb-4">
                <div className="flex items-center justify-center w-10 h-10 bg-green-100 rounded-lg">
                  <CreditCard className="w-5 h-5 text-green-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">2. Payment Terms</h2>
              </div>
              <ul className="space-y-3 text-gray-700 ml-4">
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Full payment is required at the time of booking.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Payment methods accepted: Credit Card, Debit Card, PayPal.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>7.5% VAT is already included in the total booking amount.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>A ₦10,000 refundable caution fee is required for all bookings.</span>
                </li>
              </ul>
            </div>

            {/* Section 3: Cancellation Policy */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3 mb-4">
                <div className="flex items-center justify-center w-10 h-10 bg-yellow-100 rounded-lg">
                  <Clock className="w-5 h-5 text-yellow-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">3. Cancellation Policy</h2>
              </div>
              <ul className="space-y-3 text-gray-700 ml-4">
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Cancellations must be made at least 48 hours before check-in.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Bookings cancelled within 48 hours of check-in are non-refundable.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Special event bookings have different cancellation policies.</span>
                </li>
              </ul>
            </div>

            {/* Section 4: Property Rules */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3 mb-4">
                <div className="flex items-center justify-center w-10 h-10 bg-purple-100 rounded-lg">
                  <Shield className="w-5 h-5 text-purple-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">4. Property Rules</h2>
              </div>
              <ul className="space-y-3 text-gray-700 ml-4">
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>No smoking inside the property.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>No pets allowed unless specified.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Maximum occupancy must not be exceeded.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Check-in time is 3:00 PM and check-out time is 11:00 AM.</span>
                </li>
              </ul>
            </div>

            {/* Section 5: Liability */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3 mb-4">
                <div className="flex items-center justify-center w-10 h-10 bg-red-100 rounded-lg">
                  <AlertCircle className="w-5 h-5 text-red-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">5. Liability</h2>
              </div>
              <ul className="space-y-3 text-gray-700 ml-4">
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Guests are responsible for any damages to the property.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Lost keys will incur a ₦5,000 replacement fee.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Management is not responsible for personal belongings.</span>
                </li>
              </ul>
            </div>

            {/* Section 6: Privacy Policy */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3 mb-4">
                <div className="flex items-center justify-center w-10 h-10 bg-indigo-100 rounded-lg">
                  <Lock className="w-5 h-5 text-indigo-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">6. Privacy Policy</h2>
              </div>
              <ul className="space-y-3 text-gray-700 ml-4">
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>Your personal information is protected under our privacy policy.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>We do not share your information with third parties.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pink-500 mr-2 mt-1">•</span>
                  <span>You can view our full privacy policy on our website.</span>
                </li>
              </ul>
            </div>

            {/* Agreement Section */}
            <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
              <p className="text-gray-700 leading-relaxed">
                By accepting these terms and conditions, you agree to all the policies outlined above. 
                Please contact us at <span className="font-semibold text-pink-600">support@roar.com</span> if you have any questions.
              </p>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="mt-12 text-center">
          <div className="bg-blue-50 rounded-xl p-8 border border-blue-200">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Have Questions?</h3>
            <p className="text-gray-600 mb-6">
              Our customer support team is here to help you with any questions about our terms and conditions.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="mailto:support@roar.com"
                className="inline-flex items-center justify-center px-6 py-3 bg-pink-500 text-white rounded-lg hover:bg-pink-600 transition-colors"
              >
                Email Support
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Contact Form
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
